import { render, staticRenderFns } from "./OrderReconciliationTurnover.vue?vue&type=template&id=4b84a3a4&scoped=true"
import script from "./OrderReconciliationTurnover.vue?vue&type=script&lang=js"
export * from "./OrderReconciliationTurnover.vue?vue&type=script&lang=js"
import style0 from "./OrderReconciliationTurnover.vue?vue&type=style&index=0&id=4b84a3a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84a3a4",
  null
  
)

export default component.exports